import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AuthHeaderService } from './auth-header.service';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class HttpService {
  host = environment.APIUrl;

  constructor(private _http: HttpClient, private authHeaderService: AuthHeaderService) { }

  post(url: string, data: any) {

    return this._http.post(this.host + url, data,).pipe(map(response => {
      return response;
    }, error => { }));
  }
  postWithAuth(url: string, data: any) {
    return this._http.post(this.host + url, data, { headers: this.authHeaderService.getHeader() }).pipe(map(response => {
      return response;
    }, error => { }));
  }

  get(url: string) {
    return this._http.get<any>(this.host + url).pipe(map(response => {
      return response;
    }, error => { }));
  }
  getWithAuth(url: string) {
    return this._http.get<any>(this.host + url, { headers: this.authHeaderService.getHeader() }).pipe(map(response => {
      return response;
    }, error => { }));
  }

  downloadGet(path) {
    return this._http.get(this.host + path, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res: any) => {
      if (res.body) {
        if (res.headers.get('Content-Type') == "application/json") {
          return null;
        }
        else {
          let data = {
            data: new Blob([res.body], { type: res.headers.get('Content-Type') }),
            filename: res.headers.get('File-Name')
          }
          return data;
        }
      }
      return null
    }
    ))
  }
}
